var exports = {
  "Pf": "xcc377c0b--50c627--label",
  "ff": "xcc377c0b--50c627--pros",
  "qu": "xcc377c0b--50c627--cons",
};

module.exports = exports;
